import { useCallback, useReducer } from 'react'
import { init, reducer } from './reducer'
import { useFilteredGridColumns } from './useFilteredGridColumns'
import type { FieldState, GridColumnsSelectorProps } from './typings'

export function useActions(props: GridColumnsSelectorProps) {
  const {
    apiRef,
    onCancel,
    lockedColumns,
    defaultColumns,
    defaultVisibility,
    saveCallback = () => {},
  } = props

  const internalColumns = useFilteredGridColumns(apiRef)

  const [state, dispatch] = useReducer(
    reducer,
    { defaultColumns, lockedColumns, internalColumns, defaultVisibility },
    init,
  )

  const onSave = useCallback(() => {
    const sortedFields = state.sortedColumns.map<FieldState>((c) => ({
      field: c.field,
      hide: false,
    }))

    internalColumns.orderedFields.map((field) => {
      if (!sortedFields.some((c) => c.field === field)) {
        sortedFields.push({
          field,
          hide: true,
        })
      }
    })

    saveCallback(sortedFields)
    onCancel()
  }, [
    internalColumns.orderedFields,
    onCancel,
    saveCallback,
    state.sortedColumns,
  ])

  return {
    state: { ...state, sortedColumns: [...state.sortedColumns] },
    dispatch,
    onSave,
  }
}
